import React, { Component } from 'react';
import { ModalBody, ModalFooter, FormGroup, Label, Input, FormText } from 'reactstrap';
import { APIClient } from '../../../utils/APIClient';
import { API_URL, TIKTOK_APP_ID, APP_URL, LINKEDIN_AUTHORIZATION_URL } from '../../../settings/local_settings';
import { FaIcon } from '../../FaIcon';
import { withTranslation } from 'react-i18next';
import { CHANNEL_INFO_BY_CHANNEL } from '../../channels/channels';

const STEP_SELECT = 'SELECT';
const STEP_ERROR = 'ERROR';

class PaidMediaReconnectFlowClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: STEP_SELECT,
            credentialName: '',
            errorMessage: null,
        };
        this.handleConnectNew = this.handleConnectNew.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
    }

    handleNameChange(e) {
        this.setState({ credentialName: e.target.value });
    }

    handleConnectNew() {
        const { adAccountData } = this.props;
        const { credentialName } = this.state;

        if (credentialName.trim()) {
            localStorage.setItem('pending_credential_label', credentialName.trim());
        }

        localStorage.setItem('pending_reconnect_ad_account_id', String(adAccountData.ad_account_id));
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[adAccountData.channel];
        const channelName = channelInfo ? channelInfo.Spanish : adAccountData.channel;
        localStorage.setItem('pending_reconnect_channel_name', channelName);

        if (adAccountData.channel === 'GOOGLE') {
            new APIClient(API_URL + 'get_auth_url/').call('GET')
                .then((data) => {
                    window.location = data.auth_url;
                })
                .catch(() => {
                    this.setState({ step: STEP_ERROR, errorMessage: this.props.t('reconnect_modal.error_auth_url') });
                });
        } else if (adAccountData.channel === 'TIKTOK') {
            const redirectUri = encodeURIComponent(`${APP_URL}connect-tiktok`);
            window.location = `https://business-api.tiktok.com/portal/auth?app_id=${TIKTOK_APP_ID}&state=your_custom_params&redirect_uri=${redirectUri}`;
        } else if (adAccountData.channel === 'LINKEDIN') {
            window.location = LINKEDIN_AUTHORIZATION_URL;
        } else if (adAccountData.channel === 'FACEBOOK') {
            window.location = '/agency/conections?reconnect_pending=FACEBOOK';
        }
    }

    handleRetry() {
        this.setState({ step: STEP_SELECT, errorMessage: null });
    }

    renderSelect() {
        const { t } = this.props;
        const { credentialName } = this.state;
        const isNameValid = credentialName.trim().length > 0;

        return (
            <>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('reconnect_modal.description')}</p>
                        <FormGroup style={{ marginTop: '1em' }}>
                            <Label>{t('add_credential_modal.name_label')}</Label>
                            <Input
                                type="text"
                                value={credentialName}
                                onChange={this.handleNameChange}
                                placeholder={t('add_credential_modal.name_placeholder')}
                            />
                            <FormText>{t('add_credential_modal.name_hint')}</FormText>
                        </FormGroup>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn -negative" onClick={this.props.onToggle}>
                        {t('reconnect_modal.cancel')}
                    </button>
                    <button className="btn -alt" onClick={this.handleConnectNew} disabled={!isNameValid}>
                        <FaIcon iconName="plus" /> {t('reconnect_modal.connect_new')}
                    </button>
                </ModalFooter>
            </>
        );
    }

    renderError() {
        const { t } = this.props;
        const { errorMessage } = this.state;
        return (
            <>
                <ModalBody>
                    <div className="modal-section" style={{ textAlign: 'center', padding: '2em' }}>
                        <FaIcon iconName="exclamation-triangle" style={{ color: '#DF0D00', fontSize: '3em' }} />
                        <p style={{ marginTop: '1em', fontWeight: '600' }}>{t('reconnect_modal.error_no_access')}</p>
                        <p style={{ color: '#666' }}>{errorMessage}</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn -negative" onClick={this.props.onToggle}>
                        {t('reconnect_modal.cancel')}
                    </button>
                    <button className="btn -alt" onClick={this.handleRetry}>
                        {t('reconnect_modal.retry')}
                    </button>
                </ModalFooter>
            </>
        );
    }

    render() {
        const { step } = this.state;

        switch (step) {
            case STEP_SELECT:
                return this.renderSelect();
            case STEP_ERROR:
                return this.renderError();
            default:
                return null;
        }
    }
}

export const PaidMediaReconnectFlow = withTranslation()(PaidMediaReconnectFlowClass);
